// Shared Stripe.js loader — the single sanctioned dedup between the
// Settings payment-method modal (`features/billing/PaymentMethod.tsx`) and
// the onboarding payment step (`features/onboarding/steps/Payment.tsx`).
//
// The publishable key is read from `import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY`.
// When absent, `getStripe()` resolves to `null` and callers render a
// graceful inline warning instead of mounting Elements.

import { loadStripe, type Stripe } from '@stripe/stripe-js';

interface ImportMetaEnvCustom {
  VITE_STRIPE_PUBLISHABLE_KEY?: string;
}

export function publishableKey(): string | undefined {
  const env = (import.meta as unknown as { env: ImportMetaEnvCustom }).env;
  return env?.VITE_STRIPE_PUBLISHABLE_KEY;
}

let stripePromise: Promise<Stripe | null> | null = null;

export function getStripe(): Promise<Stripe | null> {
  if (stripePromise) return stripePromise;
  const key = publishableKey();
  if (!key) {
    stripePromise = Promise.resolve(null);
    return stripePromise;
  }
  stripePromise = loadStripe(key);
  return stripePromise;
}
